import React, { Fragment } from 'react'
import { Set } from 'immutable'

// @src imports
import { useState } from 'src/hooks'
import { Drawer } from 'src/chrome'
import { getPlansAndAddOnsByTitle } from 'src/helpers'
import { addOns } from 'src/marketing/plans/constants'
import { bundlePlans, enabledPlans } from 'src/marketing/plans/plansInfo'

import Payment, {
  PaymentInfo,
  PurchaseTypes,
} from 'src/payments/containers/Payment'

import { PlansSlider } from 'src/marketing/plans/components'

import { mobilePricingTableData } from 'src/redux/selectors/plans'

type Props = {
  onClose: () => void
  planTitle: string
  addOnTitles: Set<string>
  shouldUpdateBundle?: boolean
}

const PlanDrawer: React.FC<Props> = props => {
  const { onClose, shouldUpdateBundle } = props

  const plans = shouldUpdateBundle ? bundlePlans : enabledPlans
  const [isPurchasing, setIsPurchasing] = useState(false)
  const [planTitle, setPlanTitle] = useState(props.planTitle)
  const addOnTitles = Set()

  const paymentInfo: PaymentInfo = {
    items: getPlansAndAddOnsByTitle(
      mobilePricingTableData([], [], plans),
      addOns,
      addOnTitles.add(planTitle),
    ),
    purchaseType: PurchaseTypes.PLAN,
    shouldUpdateBundle: shouldUpdateBundle,
  }

  const handlePlanSelected = (title: string) => {
    setPlanTitle(title)
  }

  const filteredPlans = plans
    ? !shouldUpdateBundle
      ? plans.filter(p => p.title !== 'Basic' && p.title !== 'Legacy')
      : plans.filter(p => p.title === planTitle)
    : []

  const tabs = filteredPlans.map(p => p.title)

  return (
    <Drawer
      openCloseControlClicked={() => (isPurchasing ? () => {} : onClose())}
      isOpen={true}
      title={'Purchase Your Subscription Package'}
      isFullScreen={true}
    >
      <Fragment>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <PlansSlider
            plans={filteredPlans}
            tabs={tabs}
            currentIndex={tabs.indexOf(planTitle)}
            onRightArrowClick={() =>
              handlePlanSelected(tabs[tabs.indexOf(planTitle) + 1])
            }
            onLeftArrowClick={() =>
              handlePlanSelected(tabs[tabs.indexOf(planTitle) - 1])
            }
            onTabClick={tab => handlePlanSelected(tab)}
            shouldSkipPlansSliderAnimation={false}
            isMediumScreen={true}
          />
        </div>
        <div style={{ marginBottom: 20 }}>
          <Payment
            paymentInfo={paymentInfo}
            onPurchasingChange={setIsPurchasing}
            onPaymentSuccess={() => onClose()}
            onClose={onClose}
          />
        </div>
      </Fragment>
    </Drawer>
  )
}

export default PlanDrawer
